import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import react from '../assets/react.png';
import circle from '../assets/circle.svg';

 let images = {
  email,
  mobile,
  html,
  javascript,
  react,
  circle,
};

export default images;